import React from 'react'
import classNames from 'classnames'

type MaxWidthGlobalProps = {
  children?: React.ReactNode
  className?: string
}

export const MaxWidthGlobal: React.FC<MaxWidthGlobalProps> = ({
  children,
  className: classNameFromProps,
}) => {
  return (
    <div className={classNames('mx-auto w-full max-w-[1920px]', classNameFromProps)}>
      {children}
    </div>
  )
}
